import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://manos-en-casa.impultienda.ar/checkout';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  href = CHECKOUT_URL,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-lg sm:text-xl shadow-block hover:shadow-blockSm' : 'px-6 py-4 text-base shadow-blockSm hover:shadow-none';
  const isExternal = href.startsWith('http');
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex items-center justify-center gap-3 rounded-full border-2 border-ink bg-clay font-display font-bold text-cream transition-all duration-200 hover:bg-clayDark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink active:translate-y-1 ${sizing} ${className}`} data-id="element-30" data-mp="10a3sc6vj9iy5">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="35zijo6g9jqme" />
    </a>;
}